export function calculeValorTroco(trocoPara: any, valorPedido: any): number {
  const trocoParaCentavos = Math.round(Number(trocoPara || 0) * 100);
  const valorPedidoCentavos = Math.round(Number(valorPedido || 0) * 100);

  return (trocoParaCentavos - valorPedidoCentavos) / 100;
}

export function ultrapassouValorMaximoTroco(trocoPara: any, valorPedido: any, valorMaximo: any): boolean {
  return calculeValorTroco(trocoPara, valorPedido) > Number(valorMaximo);
}
